import { StyleProps, CSSFn, callCSSFn } from "@shared/primitive-components"

export const makeRootStyle =
  (css?: CSSFn): CSSFn =>
  (props: StyleProps) => ({
    width: `100%`,
    flexDirection: `column`,
    marginBottom: props.theme.spacing(4),
    ...callCSSFn({ ...props, css }),
  })

export const separator = (props: StyleProps) => ({
  width: props.theme.pxToEm(60),
})

export const summary = (props: StyleProps) => ({
  margin: props.theme.spacing(4, 0, 4, 0),
})
